import PropTypes from 'prop-types'
import { Typography } from '../styled'
import theme from '../../constants/theme'
import { SectionCard, SectionHeader, IconBadge } from './styled'

function FeedbackSection({ title, icon, children }) {
  return (
    <SectionCard>
      {title && (
        <SectionHeader>
          {icon && <IconBadge>{icon}</IconBadge>}
          <Typography size="17px" bold color={theme.brandColorOrange}>
            {title}
          </Typography>
        </SectionHeader>
      )}
      {children}
    </SectionCard>
  )
}

FeedbackSection.propTypes = {
  title: PropTypes.node,
  icon: PropTypes.node,
  children: PropTypes.node,
}

export default FeedbackSection
